import { db } from '../../config/firebaseconfig'

export default function incrementRegistrationCount(codeId, userId) {
  return new Promise((resolve, reject) => {
    const codeRef = db.collection('registrationCodes').doc(codeId)
    db.runTransaction((transaction) => {
      return transaction.get(codeRef).then((doc) => {
        const uses = doc.data().uses
        const usersKey = `users.${userId}`
        transaction.update(codeRef, {uses: uses + 1, [usersKey]: true})
        resolve(uses + 1)
      })
    })
    .catch((error) => reject(error))
  })
}


// WEBPACK FOOTER //
// ./src/helpers/users/incrementRegistrationCount.js